export default __webpack_public_path__ + "static/media/093-up-arrow-1.4b5231d8.png";